import React from 'react';
import { eventType, OPERATION_TYPE, operationType, PATHNAME } from '../../util/varibles/constants';
import { TOperation2 } from '../../util/varibles/interface';
import Icon, { ICON_NAME } from '../Icon';

interface IProps {
    visible?: boolean
    className?: string
    operation: TOperation2
}

const Invoices: React.FC<IProps> = ({ visible = true, className = '', operation }) => {
    const { tenant_id } = operation;
    const invoices = operation.invoices || [];
    const relatedInvoices = invoices.filter(invoice => invoice.operation_id !== operation.id);

    if (!visible || relatedInvoices.length === 0)
        return null;

    return <div className={`flex flex-wrap items-center gap-x-1 text-[15px] leading-5 ${className}`}>
        <div className='text-comment flex'>
            <div className='w-[21px] flex items-center'>
                <Icon icon={ICON_NAME.MULTIPLE_INVOICE} size={19} />
            </div>
            <div>Invoice related:</div>
        </div>
        {relatedInvoices.map((invoice, index) => {
            const typeName = invoice.operation_type === OPERATION_TYPE.EVENT
                ? eventType[invoice.event_type!]?.name || operationType[invoice.operation_type]?.name
                : operationType[invoice.operation_type]?.name;

            return <a
                key={invoice.operation_id}
                className='link !text-[15px]'
                href={`${PATHNAME.OPERATION}/${tenant_id}/${invoice.operation_id}`}
                target='_blank'
                rel='noreferrer'
            >
                #{invoice.operation_code} | {typeName}{index < relatedInvoices.length - 1 && ','}
            </a>;
        })}
    </div>;
};

export default Invoices;
